/** A time-zone field: the IANA zones, searchable (the tour's time zone, plan §10.1
 *  B-lift). */
import { Autocomplete, TextField } from '@mui/material';
import { useMemo } from 'react';

import { timezoneOptions } from '@/components/TimezonePicker/TimezonePicker';
import type { RecordWidgetProps } from '@/features/records/editor/types';

export function TimezoneWidget(p: RecordWidgetProps) {
  const options = useMemo(timezoneOptions, []);
  const value = typeof p.value === 'string' && p.value ? p.value : null;
  return (
    <Autocomplete<string, false, false, false>
      id={p.id}
      size="small"
      fullWidth
      options={options}
      value={value}
      autoHighlight
      disabled={p.disabled}
      onChange={(_, v) => p.onChange(v)}
      renderInput={(params) => (
        <TextField
          {...params}
          error={p.error}
          placeholder="Europe/Reykjavik"
          inputProps={{ ...params.inputProps, 'aria-describedby': p.describedBy }}
        />
      )}
    />
  );
}
